import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

function Scrollable({ children }: { children: React.ReactNode }) {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  );
}

const Container = styled.div.attrs({ className: "scrollable-container" })`
  overflow-x: scroll;

  ${breakpoint("tablet")`
    overflow-x: auto;
  `}
`;

const Content = styled.div`
  width: fit-content;

  ${breakpoint("tablet")`
    width: 100%;
  `}
`;

export default Scrollable;
